//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PaymentForm',

  /*meta: {
    script: {
      stripe: {
        src: 'https://js.stripe.com/v3/',
        async: true,
        defer: true
      }
    }
  },*/

  data() {
    return {
      paymentType: 'cc', // cc or bank
      form: {
        card_holder_name: '',
        card_holder_postcode: '',
        account_name: '',
        email_address: '',
        bank_bsb: '',
        bank_account_number: ''
      },
      bankForm: {},
      futureUse: false,
      stripe: null,
      elements: null,
      cardElement: null,
      bankElement: null
    }
  },

  computed: {
    isCC() {
      return this.paymentType === 'cc'
    },

    isBank() {
      return this.paymentType === 'bank'
    }
  },

  mounted() {
    // eslint-disable-next-line
    //this.stripe = Stripe('pk_test_TfzzGCc43Ld5p7a7wtgN3pcH')
    //this.elements = this.stripe.elements()
    //this.cardElement = this.elements.create('card')
    //this.cardElement.mount(this.$refs.cardElement)
    //this.bankElement = this.elements.create('auBankAccount')
    //this.bankElement.mount(this.$refs.bankElement)
  }
}
